import { Container } from "@/design-system/Container";
import { Stack } from "@/design-system/Stack";

export function AnalyticsPageContent({ children }: React.PropsWithChildren): React.ReactNode {
  return (
    <Container fullWidth>
      <Stack gap="lg">{children}</Stack>
    </Container>
  );
}
